import * as path from "path";

import { ensureDir } from "fs-extra";

import type { BuildTask, GeneratedForm } from "../../../../Generator/src";
import type { Generator } from "../../../../Generator/src";
import { writeFileAsync } from "../../Commons/FsUtils";
import { buildActionBegin, ILogger } from "../../Commons/Logging/ILogger";
import { getLogger } from "../../Commons/Logging/StaticLogger";

export interface FormGenerator {
    readSources: Generator["readSources"];
    getAllDependenciesHash: Generator["getAllDependenciesHash"];
    getDictionary: Generator["getDictionary"];
    getLocalizedSugar: Generator["getLocalizedSugar"];

    readSourcesAndProcessSugar(task: BuildTask): Promise<GeneratedForm>;
    dispose?(): Promise<void>;
}

export interface FileBatch {
    [absoluteFileName: string]: Buffer | string;
}

export interface IFileWriter {
    writeBatch(fileBatch: FileBatch): Promise<void>;
}

class DefaultFileWriter implements IFileWriter {
    public async writeBatch(fileBatch: FileBatch): Promise<void> {
        for (const filePath of Object.keys(fileBatch)) {
            const content = fileBatch[filePath];
            if (content != undefined && content !== "") {
                await ensureDir(path.parse(filePath).dir);
                await writeFileAsync(filePath, content);
            }
        }
    }
}

export async function generateForm(
    task: BuildTask,
    generator: FormGenerator,
    parentLogger: ILogger = getLogger(),
    fileWriter: IFileWriter = new DefaultFileWriter()
): Promise<void> {
    const logger = parentLogger.withPrefix(`GENERATE:${task.gfv}`);
    const action = buildActionBegin(logger, "Generation");
    const generatedContent = await generator.readSourcesAndProcessSugar(task);
    logger.log("Writing files");
    await writeGeneratedFiles(generatedContent, path.join(task.formPath, "form"), fileWriter);
    action.complete();
}

async function writeGeneratedFiles(
    candyFormContent: GeneratedForm,
    outputDirectory: string,
    fileWriter: IFileWriter
): Promise<void> {
    const fileBatch: FileBatch = {};
    for (const [filePath, content] of Object.entries(candyFormContent)) {
        if (content) {
            const targetPath = path.join(outputDirectory, filePath);
            fileBatch[targetPath] = content;
        }
    }
    await fileWriter.writeBatch(fileBatch);
}
